import { Deserializable } from '../protocols/deserializable';

export class ScheduledRemittanceStatus implements Deserializable {
  public id!: number;
  public name!: string;

  public onDeserialize() {}
}
